import Hls from "hls.js";
import { useEffect } from "react";

// Load HLS.js locally instead of from the JS cdn.
export const useLocalHLS = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Check if running in a browser environment
      window.Hls = Hls;
    }
  }, []);
};
